import { useEffect } from "react";

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title
      ? `${title} - Xalro`
      : "Xalro - Social Casino Entertainment";
  }, [title]);
};